import { useEffect } from 'react';
import axios from 'axios';

/**
 * Hook para rastrear actividad del usuario en la aplicación
 * Envía un "heartbeat" al backend cada 2 minutos mientras el usuario está activo
 */
const useActivityTracker = () => {
  useEffect(() => {
    const API = `${window.location.origin}/api`;
    
    const sendHeartbeat = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        await axios.post(`${API}/users/heartbeat`, {}, {
          headers: { Authorization: `Bearer ${token}` }
        });
        console.log('Heartbeat enviado:', new Date().toLocaleTimeString());
      } catch (error) {
        // Silenciar errores para no molestar al usuario
        console.debug('Error enviando heartbeat:', error);
      }
    };

    // Enviar heartbeat inicial
    sendHeartbeat();

    // Enviar heartbeat cada 60 segundos (backend considera "activo" <90s)
    const interval = setInterval(sendHeartbeat, 60 * 1000);

    // Cleanup al desmontar
    return () => clearInterval(interval);
  }, []);
};

export default useActivityTracker;
